import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  connect() {
    const activeStep = this.element.querySelector(".is-active")
    if (!activeStep) return

    activeStep.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    })
  }
}